export default __webpack_public_path__ + "static/media/logo-ae-centerpoint.5601d36e.svg";